import React from 'react';

interface OwnProps {
    callbackDelay: number;
    visibilityRatio: number;
    children: React.ReactNode;
    onVisibilityCallback();
}

type Props = OwnProps;

export class TrackIntersection extends React.Component<Props> {

    public observer: IntersectionObserver = null;
    private div: HTMLElement;
    private currentIntersectionRatio: number;
    private timeoutId: any = null;

    public componentDidMount() {
        if (!this.observer) {
            this.observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
                entries.forEach((entry) => {
                    this.currentIntersectionRatio = entry.intersectionRatio;
                    if (entry.intersectionRatio >= this.props.visibilityRatio && this.timeoutId == null) {
                        this.timeoutId = setTimeout(this.onTimer, this.props.callbackDelay);
                    }
                });
            }, {
                rootMargin: '0px 0px',
                threshold: [this.props.visibilityRatio],
            });
        }
        this.observer.observe(this.div);
    }

    public componentWillUnmount() {
        if (this.observer !== null) {
            this.observer.unobserve(this.div);
            this.observer = null;
        }
        if (this.timeoutId !== null){
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }

    public render() {
        return <div
            ref={this.setRef}
        >
            {React.Children.only(this.props.children)}
        </div>;
    }

    private onTimer = () => {
        if (this.currentIntersectionRatio >= this.props.visibilityRatio) {
            this.observer.unobserve(this.div);
            this.observer = null;
            this.props.onVisibilityCallback();
        }
        this.timeoutId = null;
    };

    private setRef = (r: HTMLImageElement) => {
        this.div = r;
    };
}
